import {
  ApiService,
  ParentModel,
  requestHelper,
  type AuthService,
  type PageModel,
  type ServiceStore,
} from '@blueprint/frontend-basics'

import { TaleDto } from '@/models/dtos/tale.dto.ts'

export class TaleService extends ApiService {
  private readonly backendURL: string

  constructor(serviceStore: ServiceStore, authService: AuthService, backendURL: string) {
    super(serviceStore, authService)
    this.backendURL = backendURL
  }
  public async getTales(): Promise<PageModel<TaleDto>> {
    const headers = await this.getAuthHeaders()
    const response = await requestHelper.get(`${this.backendURL}/tale`, { headers })
    return ParentModel.fromPaginatedJson<TaleDto>(response.data, TaleDto)
  }

  public async getTale(taleId: string): Promise<TaleDto> {
    const headers = await this.getAuthHeaders()
    const response = await requestHelper.get(`${this.backendURL}/tale/${taleId}`, { headers })
    return ParentModel.fromJson(response.data, TaleDto)
  }

  public async createTale(taleData: TaleDto): Promise<TaleDto> {
    const headers = await this.getAuthHeaders()
    const response = await requestHelper.post(`${this.backendURL}/tale`, taleData, { headers })
    return ParentModel.fromJson(response.data, TaleDto)
  }

  public async updateTale(taleId: string, taleData: TaleDto): Promise<TaleDto> {
    const headers = await this.getAuthHeaders()
    const response = await requestHelper.put(`${this.backendURL}/tale/${taleId}`, taleData, {
      headers,
    })
    return ParentModel.fromJson(response.data, TaleDto)
  }

  public async deleteTale(taleId: string): Promise<void> {
    const headers = await this.getAuthHeaders()
    await requestHelper.delete(`${this.backendURL}/tale/${taleId}`, { headers })
  }
}
